export enum AppraisalSelectionType {
    LICENSE_PLATE = 'licensePlate',
    MANUAL = 'manual',
    VIN = 'vin',
}

export enum KBBVehicleOptionCategoryType {
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
}

export enum AppraisalVehicleCondition {
    EXCELLENT = 'Excellent',
    FAIR = 'Fair',
    GOOD = 'Good',
    VERY_GOOD = 'Very Good',
}
